module.exports = __webpack_public_path__ + "media/images/business/icon-case-issues-f21a09e24dd619f8763bcbfa22ecea1a.svg";